"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Encoder = __importStar(require("./encoder"));
var ICNSEncoder = __importStar(require("./icns-encoder"));
exports.encode = function (buf, options) {
    if (options === void 0) { options = { format: 'default' }; }
    return options.format === 'icns'
        ? ICNSEncoder.encode(buf)
        : Encoder.encode(buf);
};
exports.decode = function (buf, options) {
    if (options === void 0) { options = { format: 'default' }; }
    return options.format === 'icns'
        ? ICNSEncoder.decode(buf)
        : Encoder.decode(buf);
};
